// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"breadcrumbs_breadcrumbs__fgeF9"};